import { Link } from 'react-router-dom';
import register from '../../assets/images/icons/register.svg';
import logo from '../../assets/images/Logo.svg';
import Button from '../../components/Button';
import { ButtonContainer } from '../../components/Form';
import FormGroup from '../../components/FormGroup';
import Input from '../../components/Input';
import Loader from '../../components/Loader';
import { Container } from './styles';

import PasswordInputFormGroup from '../../components/PasswordInputFormGroup';
import Transitions from '../../components/Transition';
import useUpdateRegister from './useUpdateRegister';

export default function UpdateRegister() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    email,
    handleEmailChange,
    signup,
    isReadyToSignup,
    emailConfirmation,
    handleEmailConfirmationChange,
  } = useUpdateRegister();

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        <div className="asideGif">
          <img src={register} alt="busGif" />
        </div>

        <div className="asideLogin">
          <div className="loginTitle">
            <div className="labelTitle">
              <div>
                Atualize seu cadastro
              </div>
              <div className="subtitle">
                Por favor, informe os dados a seguir para atualizar seu cadastro em nosso sistema
              </div>
            </div>
            <img src={logo} alt="logo" className="logo" />
          </div>

          <div className="loginForm">
            <div className="aside">
              <div className="loginInput">
                <FormGroup error={getErrorMessageByFieldName('cpf')}>
                  <label htmlFor="login">CPF</label>
                  <Input
                    placeholder="Informe seu CPF"
                    value={cpf}
                    onChange={handleCpfChange}
                    autoComplete="new-password"
                    error={getErrorMessageByFieldName('cpf')}
                    maxLength={14}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="aside">
              <div className="loginInput">
                <FormGroup error={getErrorMessageByFieldName('email')}>
                  <label htmlFor="login">E-mail</label>
                  <Input
                    placeholder="Informe seu e-mail"
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete="new-password"
                    error={getErrorMessageByFieldName('email')}
                  />
                </FormGroup>
              </div>
              <div className="loginInput">
                <FormGroup error={getErrorMessageByFieldName('emailConfirmation')}>
                  <label htmlFor="login">Confirmação de e-mail</label>
                  <Input
                    placeholder="Confirme seu e-mail"
                    value={emailConfirmation}
                    onChange={handleEmailConfirmationChange}
                    autoComplete="new-password"
                    error={getErrorMessageByFieldName('emailConfirmation')}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="aside">
              <div className="loginInput">
                <PasswordInputFormGroup
                  label='Senha'
                  value={password}
                  onChange={handlePasswordChange}
                  error={getErrorMessageByFieldName('password')}
                />
              </div>
              <div className="loginInput">
                <PasswordInputFormGroup
                  label='Confirmação de senha'
                  value={passwordConfirmation}
                  onChange={handlePasswordConfirmationChange}
                  error={getErrorMessageByFieldName('passwordConfirmation')}
                />
              </div>
            </div>
          </div>

          <ButtonContainer flexDirection='column'>
            <Button type="button" onClick={signup} disabled={!isReadyToSignup}>
              Atualizar Cadastro
            </Button>
            <div className="backToLogin">
              <Link to="/">Realizar login</Link>
            </div>
          </ButtonContainer>
        </div>
      </Container>
    </Transitions>
  );
}
